import * as core from '../../../../../../../core'
import * as spaceSurveyStatus from '../space-survey-status'

export const RESOURCE = {
  payload: {
    description: 'In Progress',
    enumId: core.dms.models.Enum.Id.from({
      partialId: spaceSurveyStatus.RESOURCE.payload.partialId,
    }),
    id: 'IN_PROGRESS',
    name: 'In Progress',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
